import { render, staticRenderFns } from "./LicencesInformations.vue?vue&type=template&id=17bfd3de"
import script from "./LicencesInformations.vue?vue&type=script&lang=js"
export * from "./LicencesInformations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports